var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { IconButton, Menu, MenuItem, Badge, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import NotificationsIcon from '@mui/icons-material/Notifications';
import messages from 'translations/shared';
import { useNotifications } from './Notifications.hook';
var ModifiedMenuItem = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (_jsx(MenuItem, __assign({}, props, { sx: __assign({ p: 2.4, py: 0.8, fontWeight: 500, fontSize: 14, color: 'grey.900', transition: function (_a) {
                var transitions = _a.transitions;
                return transitions.create(['color']);
            }, ':hover': {
                bgcolor: 'transparent',
                color: 'primary.900',
            } }, (!!props.sx && props.sx)) }, { children: children }), void 0));
};
export var Notifications = function () {
    var formatMessage = useIntl().formatMessage;
    var _a = __read(useState(null), 2), anchorEl = _a[0], setAnchorEl = _a[1];
    var open = Boolean(anchorEl);
    var _b = useNotifications(), smsLeft = _b.smsLeft, loading = _b.loading;
    var handleClick = function (event) {
        if (!getCounter()) {
            return;
        }
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var getCounter = function () {
        if (loading || smsLeft > 10) {
            return 0;
        }
        return 1;
    };
    function getSMSContent() {
        if (loading || smsLeft > 10) {
            return null;
        }
        if (smsLeft === 0) {
            return (_jsxs(ModifiedMenuItem, __assign({ href: "/business/notifications", component: Link, onClick: handleClose, "data-cypress": "marketplace-domain" }, { children: [formatMessage(messages.noSMSCredits), '. ', formatMessage(messages.buySMSCredits)] }), void 0));
        }
        return (_jsxs(ModifiedMenuItem, __assign({ href: "/business/notifications", component: Link, onClick: handleClose, "data-cypress": "marketplace-domain" }, { children: [formatMessage(messages.fewSMSCredits, { count: smsLeft }), '. ', formatMessage(messages.buyMoreSMSCredits)] }), void 0));
    }
    return (_jsxs(_Fragment, { children: [_jsx(Tooltip, __assign({ title: _jsx(FormattedMessage, { id: "layout.topbar.notifications" }, void 0) }, { children: _jsx(IconButton, __assign({ onClick: handleClick, "aria-controls": open ? 'notifications-menu' : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, "data-cypress": "notifications-button", size: "medium" }, { children: _jsx(Badge, __assign({ badgeContent: getCounter(), color: "success" }, { children: _jsx(NotificationsIcon, {}, void 0) }), void 0) }), void 0) }), void 0), _jsx(Menu, __assign({ anchorEl: anchorEl, id: "notifications-menu", open: open, onClose: handleClose, slotProps: {
                    paper: {
                        sx: {
                            py: 1.2,
                            overflow: 'visible',
                            mt: 2,
                            width: 300,
                            boxShadow: '0px 4px 12px rgba(17,17,17,.08)',
                            border: '1px solid',
                            borderColor: 'grey.200',
                        },
                    },
                }, transformOrigin: { horizontal: 'right', vertical: 'top' }, anchorOrigin: { horizontal: 'right', vertical: 'bottom' } }, { children: getSMSContent() }), void 0)] }, void 0));
};
